import React, { useState, useMemo } from 'react';
import { Navigation } from '../components/Navigation';
import {
  TrendingUp, TrendingDown, Minus, AlertTriangle, CheckCircle, Target,
  Scissors, ChevronDown, ChevronUp, Filter, ArrowUpDown, Zap, Shield,
  Eye, DollarSign, BarChart3, Layers, Plus, X, ChevronRight
} from 'lucide-react';

// ============================================================================
// DUMMY DATA (30+ segmenter med realistiske tal)
// ============================================================================
const SEGMENTS = [
  // Meta — flere entry types og websites
  { id: 1, channel: 'Meta', campaign: 'Meta Formular', entryType: 'Kontaktformular', website: 'Gardinbus.nu', geo: 'Sjælland', spend: 145000, bookings: 280, shows: 168, sales: 71, revenue: 425000, daekning: 195000, profit: 27000, cancelRate: 0.40, showRate: 0.60, closeRate: 0.42, kpt7d: 0.32 },
  { id: 2, channel: 'Meta', campaign: 'Meta Formular', entryType: 'Kontaktformular', website: 'Gardinbussen-prisgaranti.dk', geo: 'Sjælland', spend: 88000, bookings: 195, shows: 122, sales: 58, revenue: 348000, daekning: 156000, profit: 38000, cancelRate: 0.37, showRate: 0.63, closeRate: 0.48, kpt7d: 0.36 },
  { id: 3, channel: 'Meta', campaign: 'Meta AI Booking', entryType: 'AI-booking', website: 'Bestil-Gardinbussen.dk', geo: 'Sjælland', spend: 62000, bookings: 88, shows: 70, sales: 41, revenue: 246000, daekning: 113000, profit: 41000, cancelRate: 0.20, showRate: 0.80, closeRate: 0.59, kpt7d: 0.51 },
  { id: 4, channel: 'Meta', campaign: 'Meta Web Booking', entryType: 'Webbooking', website: 'Gardinbus.nu', geo: 'Jylland', spend: 78000, bookings: 132, shows: 92, sales: 47, revenue: 282000, daekning: 130000, profit: 32000, cancelRate: 0.30, showRate: 0.70, closeRate: 0.51, kpt7d: 0.42 },
  { id: 5, channel: 'Meta', campaign: 'Meta Formular', entryType: 'Kontaktformular', website: 'Gardinbus.nu', geo: 'Fyn', spend: 35000, bookings: 78, shows: 47, sales: 18, revenue: 108000, daekning: 49000, profit: 8000, cancelRate: 0.40, showRate: 0.60, closeRate: 0.38, kpt7d: 0.30 },
  { id: 6, channel: 'Meta', campaign: 'Meta AI Booking', entryType: 'AI-booking', website: 'Bestil-Gardinbussen.dk', geo: 'Jylland', spend: 41000, bookings: 62, shows: 49, sales: 28, revenue: 168000, daekning: 78000, profit: 24000, cancelRate: 0.21, showRate: 0.79, closeRate: 0.57, kpt7d: 0.49 },
  { id: 7, channel: 'Meta', campaign: 'Meta Web Booking', entryType: 'Webbooking', website: 'Gardinbussen-prisgaranti.dk', geo: 'Fyn', spend: 22000, bookings: 41, shows: 29, sales: 16, revenue: 96000, daekning: 44000, profit: 12000, cancelRate: 0.29, showRate: 0.71, closeRate: 0.55, kpt7d: 0.44 },

  // Google Ads
  { id: 8, channel: 'Google Ads', campaign: 'Google Booking', entryType: 'Webbooking', website: 'Gardinbus.nu', geo: 'Sjælland', spend: 195000, bookings: 245, shows: 196, sales: 124, revenue: 868000, daekning: 446000, profit: 162000, cancelRate: 0.20, showRate: 0.80, closeRate: 0.63, kpt7d: 0.52 },
  { id: 9, channel: 'Google Ads', campaign: 'Google Booking', entryType: 'Webbooking', website: 'Bestil-Gardinbussen.dk', geo: 'Sjælland', spend: 128000, bookings: 162, shows: 138, sales: 91, revenue: 637000, daekning: 327000, profit: 121000, cancelRate: 0.15, showRate: 0.85, closeRate: 0.66, kpt7d: 0.56 },
  { id: 10, channel: 'Google Ads', campaign: 'Google Search Brand', entryType: 'Webbooking', website: 'Gardinbus.nu', geo: 'Jylland', spend: 86000, bookings: 124, shows: 99, sales: 67, revenue: 469000, daekning: 241000, profit: 96000, cancelRate: 0.20, showRate: 0.80, closeRate: 0.68, kpt7d: 0.54 },
  { id: 11, channel: 'Google Ads', campaign: 'Google Booking', entryType: 'Webbooking', website: 'Gardinbussen-prisgaranti.dk', geo: 'Fyn', spend: 48000, bookings: 64, shows: 52, sales: 32, revenue: 224000, daekning: 115000, profit: 38000, cancelRate: 0.19, showRate: 0.81, closeRate: 0.62, kpt7d: 0.50 },
  { id: 12, channel: 'Google Ads', campaign: 'Google Display', entryType: 'Kontaktformular', website: 'Gardinbus.nu', geo: 'Jylland', spend: 38000, bookings: 52, shows: 32, sales: 13, revenue: 78000, daekning: 36000, profit: -8000, cancelRate: 0.38, showRate: 0.62, closeRate: 0.41, kpt7d: 0.31 },
  { id: 13, channel: 'Google Ads', campaign: 'Google Search Generic', entryType: 'Webbooking', website: 'Gardinbussen-prisgaranti.dk', geo: 'Sjælland', spend: 92000, bookings: 108, shows: 90, sales: 60, revenue: 420000, daekning: 216000, profit: 78000, cancelRate: 0.17, showRate: 0.83, closeRate: 0.67, kpt7d: 0.53 },

  // Affiliates
  { id: 14, channel: 'Affiliate', campaign: 'Affiliate Lead Partner A', entryType: 'Affiliate lead', website: 'Gardinbus.nu', geo: 'Sjælland', spend: 58000, bookings: 142, shows: 78, sales: 32, revenue: 192000, daekning: 88000, profit: 14000, cancelRate: 0.45, showRate: 0.55, closeRate: 0.41, kpt7d: 0.31 },
  { id: 15, channel: 'Affiliate', campaign: 'Affiliate Lead Partner B', entryType: 'Affiliate lead', website: 'Gardinbus.nu', geo: 'Jylland', spend: 32000, bookings: 78, shows: 39, sales: 14, revenue: 84000, daekning: 38000, profit: -2000, cancelRate: 0.50, showRate: 0.50, closeRate: 0.36, kpt7d: 0.27 },
  { id: 16, channel: 'Affiliate', campaign: 'Affiliate Lead Partner C', entryType: 'Affiliate lead', website: 'Gardinbussen-prisgaranti.dk', geo: 'Fyn', spend: 18000, bookings: 38, shows: 21, sales: 9, revenue: 54000, daekning: 25000, profit: 2000, cancelRate: 0.44, showRate: 0.56, closeRate: 0.43, kpt7d: 0.34 },
  { id: 17, channel: 'Affiliate', campaign: 'Affiliate Booking Partner A', entryType: 'Affiliate booking', website: 'Bestil-Gardinbussen.dk', geo: 'Sjælland', spend: 72000, bookings: 98, shows: 76, sales: 49, revenue: 343000, daekning: 176000, profit: 64000, cancelRate: 0.22, showRate: 0.78, closeRate: 0.64, kpt7d: 0.51 },
  { id: 18, channel: 'Affiliate', campaign: 'Affiliate Booking Partner B', entryType: 'Affiliate booking', website: 'Bestil-Gardinbussen.dk', geo: 'Jylland', spend: 44000, bookings: 60, shows: 47, sales: 28, revenue: 196000, daekning: 100000, profit: 32000, cancelRate: 0.22, showRate: 0.78, closeRate: 0.59, kpt7d: 0.48 },
  { id: 19, channel: 'Affiliate', campaign: 'Affiliate Lead Partner D', entryType: 'Affiliate lead', website: 'Gardinbus.nu', geo: 'Fyn', spend: 14000, bookings: 32, shows: 17, sales: 7, revenue: 42000, daekning: 19000, profit: -1000, cancelRate: 0.47, showRate: 0.53, closeRate: 0.41, kpt7d: 0.30 },

  // Telefonbookinger (typisk dyr men høj close rate)
  { id: 20, channel: 'Direkte', campaign: 'Telefon Indkøb', entryType: 'Telefonbooking', website: 'Gardinbus.nu', geo: 'Sjælland', spend: 0, bookings: 88, shows: 79, sales: 65, revenue: 520000, daekning: 268000, profit: 138000, cancelRate: 0.10, showRate: 0.90, closeRate: 0.82, kpt7d: 0.74 },
  { id: 21, channel: 'Direkte', campaign: 'Telefon Indkøb', entryType: 'Telefonbooking', website: 'Gardinbus.nu', geo: 'Jylland', spend: 0, bookings: 52, shows: 47, sales: 38, revenue: 304000, daekning: 156000, profit: 78000, cancelRate: 0.10, showRate: 0.90, closeRate: 0.81, kpt7d: 0.73 },
  { id: 22, channel: 'Direkte', campaign: 'Telefon Indkøb', entryType: 'Telefonbooking', website: 'Gardinbus.nu', geo: 'Fyn', spend: 0, bookings: 24, shows: 22, sales: 18, revenue: 144000, daekning: 74000, profit: 38000, cancelRate: 0.08, showRate: 0.92, closeRate: 0.82, kpt7d: 0.75 },

  // Mere Meta variation
  { id: 23, channel: 'Meta', campaign: 'Meta Retargeting', entryType: 'Webbooking', website: 'Bestil-Gardinbussen.dk', geo: 'Sjælland', spend: 28000, bookings: 38, shows: 30, sales: 18, revenue: 126000, daekning: 65000, profit: 22000, cancelRate: 0.21, showRate: 0.79, closeRate: 0.60, kpt7d: 0.50 },
  { id: 24, channel: 'Meta', campaign: 'Meta Retargeting', entryType: 'Webbooking', website: 'Gardinbussen-prisgaranti.dk', geo: 'Jylland', spend: 19000, bookings: 26, shows: 21, sales: 12, revenue: 84000, daekning: 43000, profit: 13000, cancelRate: 0.19, showRate: 0.81, closeRate: 0.57, kpt7d: 0.46 },

  // Mere Google variation
  { id: 25, channel: 'Google Ads', campaign: 'Google Performance Max', entryType: 'Webbooking', website: 'Gardinbus.nu', geo: 'Sjælland', spend: 110000, bookings: 138, shows: 110, sales: 71, revenue: 497000, daekning: 256000, profit: 88000, cancelRate: 0.20, showRate: 0.80, closeRate: 0.65, kpt7d: 0.53 },
  { id: 26, channel: 'Google Ads', campaign: 'Google Performance Max', entryType: 'Webbooking', website: 'Bestil-Gardinbussen.dk', geo: 'Fyn', spend: 32000, bookings: 41, shows: 33, sales: 22, revenue: 154000, daekning: 79000, profit: 28000, cancelRate: 0.20, showRate: 0.80, closeRate: 0.67, kpt7d: 0.54 },
  { id: 27, channel: 'Google Ads', campaign: 'Google Display', entryType: 'Kontaktformular', website: 'Gardinbus.nu', geo: 'Sjælland', spend: 26000, bookings: 36, shows: 22, sales: 9, revenue: 54000, daekning: 25000, profit: -8000, cancelRate: 0.39, showRate: 0.61, closeRate: 0.41, kpt7d: 0.32 },

  // Mere Affiliate
  { id: 28, channel: 'Affiliate', campaign: 'Affiliate Booking Partner C', entryType: 'Affiliate booking', website: 'Bestil-Gardinbussen.dk', geo: 'Fyn', spend: 16000, bookings: 22, shows: 17, sales: 10, revenue: 70000, daekning: 36000, profit: 12000, cancelRate: 0.23, showRate: 0.77, closeRate: 0.59, kpt7d: 0.47 },
  { id: 29, channel: 'Affiliate', campaign: 'Affiliate Lead Partner B', entryType: 'Affiliate lead', website: 'Gardinbussen-prisgaranti.dk', geo: 'Jylland', spend: 21000, bookings: 51, shows: 25, sales: 9, revenue: 54000, daekning: 25000, profit: -3000, cancelRate: 0.51, showRate: 0.49, closeRate: 0.36, kpt7d: 0.26 },
  { id: 30, channel: 'Affiliate', campaign: 'Affiliate Lead Partner A', entryType: 'Affiliate lead', website: 'Gardinbus.nu', geo: 'Fyn', spend: 12000, bookings: 28, shows: 16, sales: 7, revenue: 42000, daekning: 19000, profit: 1000, cancelRate: 0.43, showRate: 0.57, closeRate: 0.44, kpt7d: 0.34 },
  { id: 31, channel: 'Meta', campaign: 'Meta Web Booking', entryType: 'Webbooking', website: 'Bestil-Gardinbussen.dk', geo: 'Sjælland', spend: 56000, bookings: 88, shows: 65, sales: 38, revenue: 266000, daekning: 137000, profit: 42000, cancelRate: 0.26, showRate: 0.74, closeRate: 0.58, kpt7d: 0.47 },
];

const KPT_TARGETS = { week: 0.4, month: 0.2 };

// Konsulenter — pseudo-tilknytning så funnel builderen kan filtrere ned til konsulent-niveau
const CONSULTANTS = ['Mads', 'Bo', 'Lasse', 'Anders', 'Lisette', 'Ronni'];
// Hver konsulent har en performance-multiplier til close rate (dummi)
const CONSULTANT_PERF = {
  'Mads':    { close: 1.10, share: 0.22 },
  'Bo':      { close: 1.05, share: 0.18 },
  'Lasse':   { close: 0.95, share: 0.17 },
  'Anders':  { close: 1.00, share: 0.15 },
  'Lisette': { close: 1.08, share: 0.16 },
  'Ronni':   { close: 0.92, share: 0.12 },
};

const dkk = (n) => {
  if (n == null) return '—';
  if (Math.abs(n) >= 1000000) return `${(n / 1000000).toFixed(1)}M kr`;
  if (Math.abs(n) >= 1000) return `${Math.round(n / 1000)}K kr`;
  return `${Math.round(n)} kr`;
};
const dkkExact = (n) => n == null ? '—' : Math.round(n).toLocaleString('da-DK') + ' kr';
const pct = (n) => n == null ? '—' : `${(n * 100).toFixed(0)}%`;

// Status decision based on profit per 1000 kr spend
const getStatus = (seg) => {
  const ppk = seg.spend > 0 ? (seg.profit / seg.spend) * 1000 : (seg.profit > 0 ? 9999 : 0);
  if (ppk < 0) return 'Cut';
  if (ppk >= 800) return 'Scale';
  if (ppk >= 200) return 'Hold';
  return 'Review';
};

const STATUS_COLOR = {
  Scale: { bg: 'bg-emerald-50', text: 'text-emerald-700', border: 'border-emerald-200', dot: 'bg-emerald-500' },
  Hold: { bg: 'bg-slate-50', text: 'text-slate-700', border: 'border-slate-200', dot: 'bg-slate-400' },
  Cut: { bg: 'bg-rose-50', text: 'text-rose-700', border: 'border-rose-200', dot: 'bg-rose-500' },
  Review: { bg: 'bg-amber-50', text: 'text-amber-700', border: 'border-amber-200', dot: 'bg-amber-500' },
  Protect: { bg: 'bg-blue-50', text: 'text-blue-700', border: 'border-blue-200', dot: 'bg-blue-500' },
};

// ============================================================================
// MAIN COMPONENT
// ============================================================================
export default function MarketingAnalyse() {
  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white p-3 sm:p-5">
      <Navigation />
      <div className="bg-slate-50 text-slate-900 rounded-2xl p-5 sm:p-8 mt-3" data-testid="marketing-analyse-page">
        <Header />
        <ExecutiveSummary />
        <RecommendedActions />
        <FunnelBuilder />
        <FunnelComparison />
        <PerformanceRanking />
        <CutSimulation />
        <Footer />
      </div>
    </div>
  );
}

// ----------------------------------------------------------------------------
// HEADER
// ----------------------------------------------------------------------------
const Header = () => (
  <div className="flex items-start justify-between mb-8 pb-6 border-b border-slate-200">
    <div>
      <p className="text-xs uppercase tracking-[0.18em] text-slate-400 font-semibold mb-1">Marketing Budget Dashboard</p>
      <h1 className="text-2xl sm:text-3xl font-bold text-slate-900 tracking-tight">Marketing Analyse</h1>
      <p className="text-sm text-slate-500 mt-1">Sidste 30 dage · Beslutningsgrundlag for budget-allokering</p>
    </div>
    <div className="hidden sm:flex items-center gap-2 px-3 py-1.5 bg-amber-50 border border-amber-200 rounded-lg text-xs text-amber-700 font-medium">
      <span className="w-1.5 h-1.5 rounded-full bg-amber-500"></span>
      Prototype · Dummidata
    </div>
  </div>
);

// ----------------------------------------------------------------------------
// EXECUTIVE SUMMARY
// ----------------------------------------------------------------------------
const ExecutiveSummary = () => {
  const totals = useMemo(() => {
    const t = SEGMENTS.reduce((acc, s) => ({
      spend: acc.spend + s.spend,
      revenue: acc.revenue + s.revenue,
      profit: acc.profit + s.profit,
      bookings: acc.bookings + s.bookings,
      sales: acc.sales + s.sales,
    }), { spend: 0, revenue: 0, profit: 0, bookings: 0, sales: 0 });
    return {
      ...t,
      roas: t.spend > 0 ? t.revenue / t.spend : 0,
      cpb: t.bookings > 0 ? t.spend / t.bookings : 0,
      cps: t.sales > 0 ? t.spend / t.sales : 0,
      kpt7d: 0.34,
      kpt30d: 0.18,
      potentialSavings: SEGMENTS.filter(s => getStatus(s) === 'Cut' || getStatus(s) === 'Review').reduce((a, s) => a + s.spend * 0.7, 0),
    };
  }, []);

  const cards = [
    { label: 'Total Spend', value: dkk(totals.spend), trend: -3, icon: DollarSign },
    { label: 'Total Revenue', value: dkk(totals.revenue), trend: 6, icon: TrendingUp },
    { label: 'Total Profit', value: dkk(totals.profit), trend: 12, icon: Target },
    { label: 'ROAS', value: `${totals.roas.toFixed(2)}x`, status: totals.roas >= 3 ? 'good' : totals.roas >= 2 ? 'warn' : 'bad' },
    { label: 'Cost per Sale', value: dkkExact(totals.cps) },
    { label: 'Cost per Booking', value: dkkExact(totals.cpb) },
    { label: 'KPT 7 dage', value: totals.kpt7d.toFixed(2), target: KPT_TARGETS.week, status: totals.kpt7d >= KPT_TARGETS.week ? 'good' : totals.kpt7d >= KPT_TARGETS.week * 0.8 ? 'warn' : 'bad' },
    { label: 'KPT 30 dage', value: totals.kpt30d.toFixed(2), target: KPT_TARGETS.month, status: totals.kpt30d >= KPT_TARGETS.month ? 'good' : totals.kpt30d >= KPT_TARGETS.month * 0.8 ? 'warn' : 'bad' },
    { label: 'Potentiel besparelse', value: dkk(totals.potentialSavings), highlight: 'savings' },
  ];

  return (
    <section className="mb-10">
      <SectionHeader icon={BarChart3} title="Executive summary" subtitle="Nøgletal & status på de overordnede mål" />
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
        {cards.map((c, i) => <KPICard key={i} {...c} />)}
      </div>
    </section>
  );
};

const KPICard = ({ label, value, trend, status, target, highlight, icon: Icon }) => {
  const statusBg = status === 'good' ? 'bg-emerald-50 border-emerald-200' : status === 'warn' ? 'bg-amber-50 border-amber-200' : status === 'bad' ? 'bg-rose-50 border-rose-200' : 'bg-white border-slate-200';
  const statusValueColor = status === 'good' ? 'text-emerald-700' : status === 'warn' ? 'text-amber-700' : status === 'bad' ? 'text-rose-700' : 'text-slate-900';

  return (
    <div className={`rounded-xl border p-4 ${highlight === 'savings' ? 'bg-gradient-to-br from-blue-50 to-indigo-50 border-indigo-200' : statusBg}`}>
      <div className="flex items-start justify-between">
        <p className="text-[11px] uppercase tracking-wider text-slate-500 font-medium">{label}</p>
        {Icon && <Icon className="w-3.5 h-3.5 text-slate-400" />}
      </div>
      <p className={`text-xl sm:text-2xl font-bold mt-1.5 ${highlight === 'savings' ? 'text-indigo-900' : statusValueColor}`}>{value}</p>
      <div className="mt-1.5 flex items-center gap-2 text-[11px]">
        {target != null && (
          <span className="text-slate-500">Mål: {target.toFixed(2)}</span>
        )}
        {trend != null && (
          <span className={`flex items-center gap-0.5 font-medium ${trend > 0 ? 'text-emerald-600' : trend < 0 ? 'text-rose-600' : 'text-slate-500'}`}>
            {trend > 0 ? <TrendingUp className="w-3 h-3" /> : trend < 0 ? <TrendingDown className="w-3 h-3" /> : <Minus className="w-3 h-3" />}
            {Math.abs(trend)}% vs forrige
          </span>
        )}
        {status === 'good' && target != null && <span className="text-emerald-600 font-medium">✓ over mål</span>}
        {status === 'bad' && target != null && <span className="text-rose-600 font-medium">⚠ under mål</span>}
      </div>
    </div>
  );
};

const SectionHeader = ({ icon: Icon, title, subtitle, right }) => (
  <div className="flex items-end justify-between mb-4 flex-wrap gap-3">
    <div className="flex items-center gap-3">
      <div className="w-9 h-9 rounded-lg bg-slate-900 text-white flex items-center justify-center">
        <Icon className="w-4 h-4" />
      </div>
      <div>
        <h2 className="text-base sm:text-lg font-bold text-slate-900">{title}</h2>
        {subtitle && <p className="text-xs text-slate-500">{subtitle}</p>}
      </div>
    </div>
    {right}
  </div>
);

// ----------------------------------------------------------------------------
// RECOMMENDED ACTIONS
// ----------------------------------------------------------------------------
const RecommendedActions = () => {
  const recs = [
    {
      action: 'Cut',
      segment: 'Meta Formular (alle geografier)',
      impact: 245000,
      kptRisk: 'Lav',
      reason: 'Aflysningsprocent 38-40% trækker show rate ned. CPA pr. show er 850 kr vs 540 kr på Google Booking. Ingen tab af close rate da Google kan opfange volumen.',
    },
    {
      action: 'Scale',
      segment: 'Google Booking (alle geografier)',
      impact: -180000,
      kptRisk: 'Høj positiv effekt',
      reason: 'ROAS 4,5-5,2x med 65%+ close rate. Profit pr. 1.000 kr spend er 850-950 kr. Ledig kapacitet på 145 ledige tider/uge i Jylland kan absorbere mere volumen.',
    },
    {
      action: 'Review',
      segment: 'Affiliate Lead Partner B & D',
      impact: 53000,
      kptRisk: 'Medium',
      reason: 'Negativ profit. Aflysning 47-51%, close rate 36-41%. Test reduceret budget i 2 uger eller forhandl bedre lead-kvalitet før eskalering.',
    },
    {
      action: 'Protect',
      segment: 'Telefonbookinger (Sjælland + Jylland)',
      impact: 0,
      kptRisk: 'Kritisk hvis fjernes',
      reason: '82% close rate, profit pr. booking 1.500-1.700 kr. Ingen marketing spend men højeste profit-bidrag. Sikr fortsat tilgængelighed af telefonkonsulenter.',
    },
    {
      action: 'Cut',
      segment: 'Google Display (Kontaktformular)',
      impact: 64000,
      kptRisk: 'Lav',
      reason: 'Negativ profit (-16K kr) på 64K kr spend. Display-trafik konverterer 15-20% lavere end Search. Re-allokér til Performance Max.',
    },
  ];

  const totalSavings = recs.filter(r => r.action === 'Cut' || r.action === 'Review').reduce((a, r) => a + r.impact, 0);

  return (
    <section className="mb-10">
      <SectionHeader
        icon={Zap}
        title="Anbefalede handlinger"
        subtitle="Top 5 prioriterede beslutninger baseret på profit, KPT og volumen"
        right={
          <div className="text-xs px-3 py-1.5 bg-emerald-50 border border-emerald-200 rounded-lg">
            <span className="text-slate-500">Potentiel netto-effekt:</span>{' '}
            <span className="font-bold text-emerald-700">+{dkk(totalSavings)} /mdr</span>
          </div>
        }
      />
      <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-3">
        {recs.map((r, i) => <ActionCard key={i} {...r} />)}
      </div>
    </section>
  );
};

const ActionIcon = {
  Cut: Scissors,
  Scale: TrendingUp,
  Review: Eye,
  Protect: Shield,
  Hold: Minus,
};

const ActionCard = ({ action, segment, impact, kptRisk, reason }) => {
  const colors = STATUS_COLOR[action] || STATUS_COLOR.Hold;
  const Icon = ActionIcon[action] || Minus;

  return (
    <div className={`rounded-xl border-2 ${colors.border} ${colors.bg} p-4`}>
      <div className="flex items-start justify-between mb-2">
        <div className="flex items-center gap-2">
          <div className={`w-8 h-8 rounded-lg ${colors.dot} flex items-center justify-center text-white`}>
            <Icon className="w-4 h-4" />
          </div>
          <div>
            <p className={`text-[10px] font-bold uppercase tracking-wider ${colors.text}`}>{action}</p>
            <p className="text-sm font-bold text-slate-900 leading-tight">{segment}</p>
          </div>
        </div>
      </div>
      <p className="text-xs text-slate-600 leading-relaxed mb-3 mt-2">{reason}</p>
      <div className="flex items-center justify-between pt-3 border-t border-slate-200/60">
        <div>
          <p className="text-[10px] uppercase tracking-wider text-slate-500">Effekt</p>
          <p className={`text-sm font-bold ${impact > 0 ? 'text-emerald-700' : impact < 0 ? 'text-blue-700' : 'text-slate-700'}`}>
            {impact > 0 ? `+${dkk(impact)}` : impact < 0 ? dkk(Math.abs(impact)) + ' merspend' : 'Ingen ændring'}
          </p>
        </div>
        <div className="text-right">
          <p className="text-[10px] uppercase tracking-wider text-slate-500">KPT-risiko</p>
          <p className="text-sm font-medium text-slate-700">{kptRisk}</p>
        </div>
      </div>
    </div>
  );
};

// ----------------------------------------------------------------------------
// FUNNEL BUILDER — Interaktiv step-by-step path builder med comparison
// ----------------------------------------------------------------------------
const LEVELS = [
  { key: 'channel',   label: 'Kanal',      icon: '📊' },
  { key: 'website',   label: 'Website',    icon: '🌐' },
  { key: 'entryType', label: 'Entry type', icon: '↪' },
  { key: 'geo',       label: 'Geografi',   icon: '📍' },
  { key: 'consultant',label: 'Konsulent',  icon: '👤' },
];

const ENTRY_TYPES_ALL = ['Telefonbooking', 'Webbooking', 'Chat', 'Kontaktformular', 'AI-booking', 'Affiliate lead', 'Affiliate booking'];

// Compute available options at a level given previously selected filters
const optionsForLevel = (levelKey, selected) => {
  if (levelKey === 'consultant') return CONSULTANTS;
  if (levelKey === 'entryType') {
    // Use all defined entry types so user can experiment, but only show relevant ones for prototype data
    const relevant = new Set(SEGMENTS.filter(s => matches(s, selected)).map(s => s.entryType));
    // Add entries from ENTRY_TYPES_ALL even without data so UI looks complete (they will just have 0 metrics)
    const merged = new Set([...relevant]);
    ENTRY_TYPES_ALL.forEach(e => {
      if ((selected.channel === 'Direkte' && e === 'Telefonbooking') || selected.channel !== 'Direkte') merged.add(e);
    });
    return Array.from(merged);
  }
  const filtered = SEGMENTS.filter(s => matches(s, selected));
  return Array.from(new Set(filtered.map(s => s[levelKey]))).filter(Boolean);
};

const matches = (seg, selected) => {
  // Only check the known filter levels, not arbitrary keys like `id`
  for (const l of LEVELS) {
    if (l.key === 'consultant') continue; // consultant filter applied later
    if (selected[l.key] && seg[l.key] !== selected[l.key]) return false;
  }
  return true;
};

// Aggregate metrics for a path. Consultant scaling applied at the very end if selected.
const aggregateForPath = (selected) => {
  const filtered = SEGMENTS.filter(s => matches(s, selected));
  if (filtered.length === 0) {
    return { spend: 0, bookings: 0, shows: 0, sales: 0, revenue: 0, daekning: 0, profit: 0, hasData: false };
  }
  const sum = filtered.reduce((a, s) => ({
    spend: a.spend + s.spend,
    bookings: a.bookings + s.bookings,
    shows: a.shows + s.shows,
    sales: a.sales + s.sales,
    revenue: a.revenue + s.revenue,
    daekning: a.daekning + s.daekning,
    profit: a.profit + s.profit,
    cancelRateSum: a.cancelRateSum + s.cancelRate,
    closeRateSum: a.closeRateSum + s.closeRate,
  }), { spend: 0, bookings: 0, shows: 0, sales: 0, revenue: 0, daekning: 0, profit: 0, cancelRateSum: 0, closeRateSum: 0 });

  let cons = selected.consultant ? CONSULTANT_PERF[selected.consultant] : null;
  if (cons) {
    // Apply consultant share + performance to bookings/shows/sales
    sum.bookings = Math.round(sum.bookings * cons.share);
    sum.shows = Math.round(sum.shows * cons.share);
    const adjustedSales = Math.round(sum.shows * (sum.shows > 0 ? (sum.closeRateSum / filtered.length) * cons.close : 0));
    const salesFactor = sum.sales > 0 ? adjustedSales / sum.sales : 1;
    sum.sales = adjustedSales;
    sum.revenue = Math.round(sum.revenue * cons.share * cons.close);
    sum.daekning = Math.round(sum.daekning * cons.share * cons.close);
    sum.spend = Math.round(sum.spend * cons.share);
    sum.profit = Math.round(sum.profit * cons.share * cons.close);
  }

  return {
    spend: sum.spend,
    bookings: sum.bookings,
    shows: sum.shows,
    sales: sum.sales,
    revenue: sum.revenue,
    daekning: sum.daekning,
    profit: sum.profit,
    cancelRate: filtered.length ? sum.cancelRateSum / filtered.length : 0,
    showRate: sum.bookings > 0 ? sum.shows / sum.bookings : 0,
    closeRate: sum.shows > 0 ? sum.sales / sum.shows : 0,
    cpb: sum.bookings > 0 ? sum.spend / sum.bookings : 0,
    profitPerBooking: sum.bookings > 0 ? sum.profit / sum.bookings : 0,
    profitPer1k: sum.spend > 0 ? (sum.profit / sum.spend) * 1000 : 0,
    daekningPerOrder: sum.sales > 0 ? sum.daekning / sum.sales : 0,
    hasData: true,
  };
};

const FunnelBuilder = () => {
  // Each funnel is { id, channel, website, entryType, geo, consultant }
  const [funnels, setFunnels] = useState([{ id: 1 }]);

  const addFunnel = () => {
    if (funnels.length >= 3) return;
    setFunnels(f => [...f, { id: Date.now() }]);
  };

  const removeFunnel = (id) => {
    setFunnels(f => f.length > 1 ? f.filter(x => x.id !== id) : f);
  };

  const updateFunnel = (id, updater) => {
    setFunnels(fs => fs.map(f => f.id === id ? updater(f) : f));
  };

  return (
    <section className="mb-10">
      <SectionHeader
        icon={Layers}
        title="Funnel Builder"
        subtitle="Byg din egen tragt trin for trin og find præcis hvor værdien tabes"
        right={
          funnels.length < 3 && (
            <button
              onClick={addFunnel}
              className="flex items-center gap-1.5 px-3 py-1.5 bg-slate-900 text-white text-xs font-medium rounded-lg hover:bg-slate-800 transition-colors"
              data-testid="add-funnel-btn"
            >
              <Plus className="w-3.5 h-3.5" />
              Tilføj sammenligning
            </button>
          )
        }
      />

      <div className={`grid gap-4 ${funnels.length === 1 ? 'grid-cols-1' : funnels.length === 2 ? 'grid-cols-1 lg:grid-cols-2' : 'grid-cols-1 lg:grid-cols-3'}`}>
        {funnels.map((f, idx) => (
          <FunnelBuilderCard
            key={f.id}
            funnel={f}
            index={idx}
            canRemove={funnels.length > 1}
            onChange={(updater) => updateFunnel(f.id, updater)}
            onRemove={() => removeFunnel(f.id)}
          />
        ))}
      </div>
    </section>
  );
};

const FunnelBuilderCard = ({ funnel, index, canRemove, onChange, onRemove }) => {
  // Find the next level to choose
  const filledLevels = LEVELS.filter(l => funnel[l.key]);
  const nextLevel = LEVELS.find(l => !funnel[l.key]);

  const setLevel = (key, value) => {
    onChange(prev => {
      const updated = { ...prev, [key]: value };
      // Reset all levels after this one to keep path consistent
      const idx = LEVELS.findIndex(l => l.key === key);
      LEVELS.slice(idx + 1).forEach(l => { delete updated[l.key]; });
      return updated;
    });
  };

  const clearLevel = (key) => {
    onChange(prev => {
      const updated = { ...prev };
      const idx = LEVELS.findIndex(l => l.key === key);
      LEVELS.slice(idx).forEach(l => { delete updated[l.key]; });
      return updated;
    });
  };

  const reset = () => onChange(() => ({ id: funnel.id }));

  const metrics = useMemo(() => aggregateForPath(funnel), [funnel]);

  return (
    <div className="bg-white rounded-xl border border-slate-200 p-5 flex flex-col" data-testid={`funnel-builder-${index}`}>
      {/* Header with breadcrumb path */}
      <div className="flex items-start justify-between gap-2 mb-4">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-1.5 mb-1">
            <span className="text-[10px] font-bold uppercase tracking-wider text-slate-400">Tragt {index + 1}</span>
            {filledLevels.length > 0 && (
              <button
                onClick={reset}
                className="text-[10px] text-slate-400 hover:text-slate-700 underline"
                data-testid={`reset-funnel-${index}`}
              >
                Nulstil
              </button>
            )}
          </div>
          {/* Breadcrumb */}
          {filledLevels.length === 0 ? (
            <p className="text-sm text-slate-400">Vælg en kanal for at starte</p>
          ) : (
            <div className="flex items-center gap-1 flex-wrap">
              {filledLevels.map((l, i) => (
                <React.Fragment key={l.key}>
                  {i > 0 && <ChevronRight className="w-3.5 h-3.5 text-slate-300" />}
                  <button
                    onClick={() => clearLevel(l.key)}
                    className="text-xs px-2 py-0.5 bg-slate-900 text-white rounded-md font-medium hover:bg-slate-700 transition-colors"
                    title="Fjern dette filter"
                  >
                    {funnel[l.key]} <span className="text-white/40 ml-1">×</span>
                  </button>
                </React.Fragment>
              ))}
            </div>
          )}
        </div>
        {canRemove && (
          <button
            onClick={onRemove}
            className="p-1 text-slate-400 hover:text-rose-600 hover:bg-rose-50 rounded-lg transition-colors flex-shrink-0"
            title="Fjern denne tragt"
            data-testid={`remove-funnel-${index}`}
          >
            <X className="w-4 h-4" />
          </button>
        )}
      </div>

      {/* Step selector */}
      {nextLevel && (
        <div className="mb-4 pb-4 border-b border-slate-100">
          <p className="text-[11px] uppercase tracking-wider text-slate-500 font-semibold mb-2">
            <span className="text-slate-400">Trin {LEVELS.findIndex(l => l.key === nextLevel.key) + 1}/5:</span> Vælg {nextLevel.label.toLowerCase()}
          </p>
          <div className="flex flex-wrap gap-1.5">
            {optionsForLevel(nextLevel.key, funnel).map(opt => (
              <button
                key={opt}
                onClick={() => setLevel(nextLevel.key, opt)}
                className="px-3 py-1.5 bg-slate-50 hover:bg-slate-900 hover:text-white border border-slate-200 hover:border-slate-900 rounded-lg text-xs font-medium text-slate-700 transition-all"
                data-testid={`option-${nextLevel.key}-${opt.toLowerCase().replace(/[^a-z]/g, '')}`}
              >
                {opt}
              </button>
            ))}
            {optionsForLevel(nextLevel.key, funnel).length === 0 && (
              <p className="text-xs text-slate-400 italic">Ingen tilgængelige muligheder for denne sti</p>
            )}
          </div>
        </div>
      )}

      {/* Funnel visualization + metrics (always shown if at least 1 level chosen) */}
      {filledLevels.length === 0 ? (
        <div className="flex-1 flex items-center justify-center text-center py-12 text-slate-400 text-sm">
          <div>
            <Layers className="w-10 h-10 mx-auto mb-2 text-slate-300" />
            Start med at vælge en kanal ovenfor
          </div>
        </div>
      ) : metrics.hasData ? (
        <FunnelVisualization metrics={metrics} />
      ) : (
        <div className="flex-1 flex items-center justify-center text-center py-12 text-slate-400 text-sm">
          Ingen data for denne kombination
        </div>
      )}
    </div>
  );
};

const FunnelVisualization = ({ metrics }) => {
  // Calculate widths based on absolute values (bookings = 100%)
  const max = metrics.bookings || 1;
  const showW = (metrics.shows / max) * 100;
  const saleW = (metrics.sales / max) * 100;

  // Identify weakest step
  const weakShow = metrics.showRate < 0.7;
  const weakClose = metrics.closeRate < 0.55;
  const weakest = weakShow && metrics.showRate / 0.7 < metrics.closeRate / 0.55 ? 'show' : weakClose ? 'close' : null;

  // Conversion percentages between steps
  const bookingToShow = metrics.bookings > 0 ? (metrics.shows / metrics.bookings) * 100 : 0;
  const showToSale = metrics.shows > 0 ? (metrics.sales / metrics.shows) * 100 : 0;

  return (
    <div className="space-y-4 flex-1">
      {/* Visual funnel — 3 stages with width proportional to volume */}
      <div className="space-y-1">
        <FunnelStage
          label="Bookinger"
          value={metrics.bookings}
          width={100}
          color="bg-slate-900"
        />
        <ConvArrow pct={bookingToShow} weak={weakest === 'show'} />
        <FunnelStage
          label="Shows"
          value={metrics.shows}
          width={Math.max(showW, 12)}
          color={weakShow ? 'bg-amber-400' : 'bg-emerald-500'}
          highlight={weakest === 'show'}
        />
        <ConvArrow pct={showToSale} weak={weakest === 'close'} />
        <FunnelStage
          label="Sales"
          value={metrics.sales}
          width={Math.max(saleW, 8)}
          color={weakClose ? 'bg-rose-500' : 'bg-blue-500'}
          highlight={weakest === 'close'}
        />
      </div>

      {/* Metrics grid */}
      <div className="grid grid-cols-2 gap-2 pt-3 border-t border-slate-100">
        <Metric label="Spend" value={dkkExact(metrics.spend)} />
        <Metric label="Pris pr. booking" value={dkkExact(metrics.cpb)} />
        <Metric label="Show rate" value={pct(metrics.showRate)} bad={metrics.showRate < 0.7} good={metrics.showRate >= 0.8} />
        <Metric label="Close rate" value={pct(metrics.closeRate)} bad={metrics.closeRate < 0.55} good={metrics.closeRate >= 0.65} />
        <Metric label="Dækning pr. ordre" value={dkkExact(metrics.daekningPerOrder)} />
        <Metric label="Profit" value={dkkExact(metrics.profit)} good={metrics.profit > 50000} bad={metrics.profit < 0} />
        <Metric label="Profit pr. booking" value={dkkExact(metrics.profitPerBooking)} good={metrics.profitPerBooking > 500} />
        <Metric label="Profit / 1.000 kr spend" value={`${Math.round(metrics.profitPer1k)} kr`} good={metrics.profitPer1k >= 800} bad={metrics.profitPer1k < 0} />
      </div>
    </div>
  );
};

const FunnelStage = ({ label, value, width, color, highlight }) => (
  <div>
    <div className="flex items-center justify-between text-xs mb-1">
      <span className={`font-semibold ${highlight ? 'text-rose-600' : 'text-slate-700'}`}>
        {label}{highlight && ' ⚠ svageste trin'}
      </span>
      <span className="text-slate-700 tabular-nums font-medium">{value.toLocaleString('da-DK')}</span>
    </div>
    <div className="h-7 bg-slate-100 rounded-md overflow-hidden flex items-center">
      <div className={`h-full ${color} rounded-md flex items-center justify-end px-2 text-[10px] text-white font-bold transition-all`} style={{ width: `${Math.max(width, 4)}%` }}>
        {width >= 20 && `${Math.round(width)}%`}
      </div>
    </div>
  </div>
);

const ConvArrow = ({ pct, weak }) => (
  <div className={`flex items-center gap-1.5 pl-2 py-0.5 ${weak ? 'text-rose-600' : 'text-slate-400'}`}>
    <div className="w-px h-3 bg-current opacity-30"></div>
    <span className="text-[10px] font-medium tabular-nums">↓ {pct.toFixed(0)}% går videre</span>
  </div>
);

// ----------------------------------------------------------------------------
// FUNNEL COMPARISON
// ----------------------------------------------------------------------------
const FunnelComparison = () => {
  const [groupBy, setGroupBy] = useState('channel');

  const groups = useMemo(() => {
    const key = groupBy === 'channel' ? 'channel' : groupBy === 'website' ? 'website' : groupBy === 'entry' ? 'entryType' : 'geo';
    const acc = {};
    SEGMENTS.forEach(s => {
      const k = s[key];
      if (!acc[k]) acc[k] = { name: k, spend: 0, bookings: 0, shows: 0, sales: 0, revenue: 0, daekning: 0, profit: 0, cancelRate: [], closeRate: [] };
      acc[k].spend += s.spend;
      acc[k].bookings += s.bookings;
      acc[k].shows += s.shows;
      acc[k].sales += s.sales;
      acc[k].revenue += s.revenue;
      acc[k].daekning += s.daekning;
      acc[k].profit += s.profit;
      acc[k].cancelRate.push(s.cancelRate);
      acc[k].closeRate.push(s.closeRate);
    });
    return Object.values(acc).map(g => ({
      ...g,
      cancelRate: g.cancelRate.length ? g.cancelRate.reduce((a, b) => a + b, 0) / g.cancelRate.length : 0,
      showRate: g.bookings > 0 ? g.shows / g.bookings : 0,
      closeRate: g.shows > 0 ? g.sales / g.shows : 0,
      cpb: g.bookings > 0 ? g.spend / g.bookings : 0,
      profitPerBooking: g.bookings > 0 ? g.profit / g.bookings : 0,
      profitPer1k: g.spend > 0 ? (g.profit / g.spend) * 1000 : 0,
      daekningPerOrder: g.sales > 0 ? g.daekning / g.sales : 0,
    })).sort((a, b) => b.profit - a.profit);
  }, [groupBy]);

  return (
    <section className="mb-10">
      <SectionHeader
        icon={Filter}
        title="Funnel sammenligning"
        subtitle="Sammenlign hvor værdien tabes undervejs i tragten — find det svageste led"
        right={
          <div className="flex items-center gap-2 bg-white border border-slate-200 rounded-lg px-3 py-1.5">
            <span className="text-xs text-slate-500">Sammenlign efter:</span>
            <select
              value={groupBy}
              onChange={(e) => setGroupBy(e.target.value)}
              className="text-sm font-medium text-slate-900 bg-transparent border-0 focus:outline-none cursor-pointer"
              data-testid="funnel-groupby-select"
            >
              <option value="channel">Kanal</option>
              <option value="website">Website</option>
              <option value="entry">Entry type</option>
              <option value="geo">Geografi</option>
            </select>
          </div>
        }
      />

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {groups.map(g => <FunnelCard key={g.name} group={g} />)}
      </div>
    </section>
  );
};

const FunnelCard = ({ group }) => {
  // Identify weakest step
  const steps = [
    { key: 'show', label: 'Show rate', value: group.showRate, threshold: 0.7 },
    { key: 'close', label: 'Close rate', value: group.closeRate, threshold: 0.55 },
  ];
  const weakest = steps.reduce((min, s) => (s.value / s.threshold) < (min.value / min.threshold) ? s : min, steps[0]);

  // Bar widths for funnel
  const max = group.bookings || 1;
  const showW = (group.shows / max) * 100;
  const saleW = (group.sales / max) * 100;

  return (
    <div className="bg-white rounded-xl border border-slate-200 p-5" data-testid={`funnel-${group.name.toLowerCase().replace(/[^a-z]/g, '')}`}>
      <div className="flex items-start justify-between mb-4">
        <h3 className="font-bold text-slate-900">{group.name}</h3>
        <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${group.profitPer1k >= 800 ? 'bg-emerald-100 text-emerald-700' : group.profitPer1k >= 200 ? 'bg-slate-100 text-slate-700' : 'bg-rose-100 text-rose-700'}`}>
          {group.profitPer1k >= 0 ? '+' : ''}{Math.round(group.profitPer1k)} kr / 1K spend
        </span>
      </div>

      {/* Funnel bars */}
      <div className="space-y-2 mb-4">
        <FunnelStep label="Bookinger" value={group.bookings.toLocaleString('da-DK')} width={100} color="bg-slate-900" />
        <FunnelStep label="Shows" value={`${group.shows.toLocaleString('da-DK')} (${pct(group.showRate)})`} width={showW} color={group.showRate < 0.7 ? 'bg-amber-400' : 'bg-emerald-500'} highlight={weakest.key === 'show'} />
        <FunnelStep label="Sales" value={`${group.sales.toLocaleString('da-DK')} (${pct(group.closeRate)} af shows)`} width={saleW} color={group.closeRate < 0.55 ? 'bg-rose-400' : 'bg-blue-500'} highlight={weakest.key === 'close'} />
      </div>

      {/* Metrics grid */}
      <div className="grid grid-cols-2 gap-2 text-xs pt-3 border-t border-slate-100">
        <Metric label="Pris pr. booking" value={dkkExact(group.cpb)} />
        <Metric label="Aflysning" value={pct(group.cancelRate)} bad={group.cancelRate > 0.30} />
        <Metric label="Close rate (konsulent)" value={pct(group.closeRate)} bad={group.closeRate < 0.55} good={group.closeRate >= 0.65} />
        <Metric label="Dækning pr. ordre" value={dkkExact(group.daekningPerOrder)} />
        <Metric label="Profit pr. booking" value={dkkExact(group.profitPerBooking)} good={group.profitPerBooking > 500} />
        <Metric label="Profit / 1.000 kr spend" value={`${Math.round(group.profitPer1k)} kr`} good={group.profitPer1k >= 800} bad={group.profitPer1k < 0} />
      </div>
    </div>
  );
};

const FunnelStep = ({ label, value, width, color, highlight }) => (
  <div>
    <div className="flex items-center justify-between text-[11px] mb-1">
      <span className={`font-medium ${highlight ? 'text-rose-600' : 'text-slate-600'}`}>
        {label}{highlight && ' ⚠'}
      </span>
      <span className="text-slate-700 tabular-nums">{value}</span>
    </div>
    <div className="h-2.5 bg-slate-100 rounded-full overflow-hidden">
      <div className={`h-full ${color} rounded-full transition-all`} style={{ width: `${Math.max(width, 4)}%` }}></div>
    </div>
  </div>
);

const Metric = ({ label, value, good, bad }) => (
  <div className="bg-slate-50 rounded-lg p-2">
    <p className="text-[10px] text-slate-500 uppercase tracking-wide truncate">{label}</p>
    <p className={`font-semibold tabular-nums ${good ? 'text-emerald-700' : bad ? 'text-rose-700' : 'text-slate-900'}`}>{value}</p>
  </div>
);

// ----------------------------------------------------------------------------
// PERFORMANCE RANKING TABLE
// ----------------------------------------------------------------------------
const PerformanceRanking = () => {
  const [sortKey, setSortKey] = useState('profitPer1k');
  const [sortDir, setSortDir] = useState('desc');

  const enriched = useMemo(() => {
    return SEGMENTS.map(s => ({
      ...s,
      cpb: s.bookings > 0 ? s.spend / s.bookings : 0,
      cps: s.sales > 0 ? s.spend / s.sales : 0,
      cpShow: s.shows > 0 ? s.spend / s.shows : 0,
      roas: s.spend > 0 ? s.revenue / s.spend : 0,
      profitPer1k: s.spend > 0 ? (s.profit / s.spend) * 1000 : (s.profit > 0 ? 9999 : 0),
      status: getStatus(s),
    }));
  }, []);

  const sorted = useMemo(() => {
    const copy = [...enriched];
    copy.sort((a, b) => {
      const av = a[sortKey], bv = b[sortKey];
      if (typeof av === 'string') return sortDir === 'asc' ? av.localeCompare(bv) : bv.localeCompare(av);
      return sortDir === 'asc' ? (av - bv) : (bv - av);
    });
    return copy;
  }, [enriched, sortKey, sortDir]);

  const onSort = (key) => {
    if (sortKey === key) setSortDir(d => d === 'asc' ? 'desc' : 'asc');
    else { setSortKey(key); setSortDir('desc'); }
  };

  const cols = [
    { key: 'channel', label: 'Kanal', sticky: true, type: 'text' },
    { key: 'campaign', label: 'Kampagne', type: 'text' },
    { key: 'entryType', label: 'Entry', type: 'text' },
    { key: 'website', label: 'Website', type: 'text' },
    { key: 'geo', label: 'Geo', type: 'text' },
    { key: 'spend', label: 'Spend', type: 'kr' },
    { key: 'bookings', label: 'Book', type: 'num' },
    { key: 'shows', label: 'Shows', type: 'num' },
    { key: 'sales', label: 'Sales', type: 'num' },
    { key: 'revenue', label: 'Revenue', type: 'kr' },
    { key: 'daekning', label: 'Dækning', type: 'kr' },
    { key: 'profit', label: 'Profit', type: 'kr', highlight: true },
    { key: 'cpb', label: 'CPB', type: 'kr' },
    { key: 'cpShow', label: 'CPS (show)', type: 'kr' },
    { key: 'cps', label: 'CPS (sale)', type: 'kr' },
    { key: 'roas', label: 'ROAS', type: 'roas' },
    { key: 'profitPer1k', label: 'Profit/1K', type: 'kr', highlight: true },
    { key: 'status', label: 'Status', type: 'status' },
  ];

  const fmt = (v, type) => {
    if (type === 'kr') return v === 0 ? '—' : Math.round(v).toLocaleString('da-DK');
    if (type === 'num') return v.toLocaleString('da-DK');
    if (type === 'roas') return `${v.toFixed(2)}x`;
    if (type === 'status') {
      const c = STATUS_COLOR[v];
      return <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-bold ${c.bg} ${c.text} border ${c.border}`}><span className={`w-1.5 h-1.5 rounded-full ${c.dot}`}></span>{v}</span>;
    }
    return v;
  };

  return (
    <section className="mb-10">
      <SectionHeader icon={ArrowUpDown} title="Performance ranking" subtitle="Alle segmenter — klik på en kolonne for at sortere" />
      <div className="bg-white rounded-xl border border-slate-200 overflow-x-auto" data-testid="performance-ranking-table">
        <table className="w-full text-xs">
          <thead className="bg-slate-50 border-b border-slate-200">
            <tr>
              {cols.map(col => {
                const sortable = col.type !== 'text' && col.type !== 'status';
                return (
                  <th
                    key={col.key}
                    onClick={() => sortable && onSort(col.key)}
                    className={`text-left py-3 px-3 font-semibold text-slate-600 whitespace-nowrap ${sortable ? 'cursor-pointer hover:bg-slate-100' : ''} ${col.highlight ? 'text-slate-900' : ''} ${col.sticky ? 'sticky left-0 bg-slate-50' : ''}`}
                  >
                    <span className="inline-flex items-center gap-1">
                      {col.label}
                      {sortKey === col.key && (sortDir === 'desc' ? <ChevronDown className="w-3 h-3" /> : <ChevronUp className="w-3 h-3" />)}
                    </span>
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {sorted.map((row, i) => (
              <tr key={row.id} className={`border-b border-slate-100 hover:bg-slate-50 ${i % 2 === 0 ? '' : 'bg-slate-50/30'}`}>
                {cols.map(col => (
                  <td
                    key={col.key}
                    className={`py-2.5 px-3 whitespace-nowrap tabular-nums ${col.highlight ? 'font-bold text-slate-900' : 'text-slate-700'} ${col.sticky ? 'sticky left-0 bg-inherit font-medium text-slate-900' : ''} ${col.type === 'kr' && row[col.key] < 0 ? 'text-rose-600' : ''}`}
                  >
                    {fmt(row[col.key], col.type)}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};

// ----------------------------------------------------------------------------
// CUT SIMULATION
// ----------------------------------------------------------------------------
const CutSimulation = () => {
  const [cutPct, setCutPct] = useState(10);

  const sim = useMemo(() => {
    const sorted = [...SEGMENTS].sort((a, b) => {
      const pa = a.spend > 0 ? (a.profit / a.spend) * 1000 : (a.profit > 0 ? 9999 : 0);
      const pb = b.spend > 0 ? (b.profit / b.spend) * 1000 : (b.profit > 0 ? 9999 : 0);
      return pa - pb;
    });
    const cutCount = Math.ceil(sorted.length * (cutPct / 100));
    const toCut = sorted.slice(0, cutCount);
    const remain = sorted.slice(cutCount);

    const savedSpend = toCut.reduce((a, s) => a + s.spend, 0);
    const lostRevenue = toCut.reduce((a, s) => a + s.revenue, 0);
    const lostProfit = toCut.reduce((a, s) => a + s.profit, 0);
    const profitDelta = savedSpend - lostRevenue + (lostRevenue - lostProfit - lostProfit > 0 ? 0 : 0);
    // net profit change = -profit_lost (since spend was already deducted in profit)
    const netProfitChange = -lostProfit;

    const remainBookings = remain.reduce((a, s) => a + s.bookings, 0);
    const totalBookings = SEGMENTS.reduce((a, s) => a + s.bookings, 0);
    const cutBookings = totalBookings - remainBookings;
    const newKpt7d = 0.34 * (remainBookings / totalBookings) + 0.34 * 0.05; // dampening
    const newRoas = (remain.reduce((a, s) => a + s.revenue, 0)) / Math.max(1, remain.reduce((a, s) => a + s.spend, 0));

    return {
      cutCount,
      savedSpend,
      lostRevenue,
      cutBookings,
      netProfitChange,
      newKpt7d,
      newRoas,
      cutSegments: toCut,
    };
  }, [cutPct]);

  const kptWarn = sim.newKpt7d < KPT_TARGETS.week;

  return (
    <section className="mb-6">
      <SectionHeader
        icon={Scissors}
        title="Cut simulation"
        subtitle="Simulér hvad der sker hvis vi skærer de svageste segmenter"
      />

      <div className="bg-white rounded-xl border border-slate-200 p-5">
        {/* Slider buttons */}
        <div className="flex items-center gap-2 mb-5">
          <span className="text-sm text-slate-600 mr-1">Cut bottom:</span>
          {[10, 20, 30].map(p => (
            <button
              key={p}
              onClick={() => setCutPct(p)}
              className={`px-4 py-1.5 rounded-lg text-sm font-medium transition-colors ${
                cutPct === p ? 'bg-slate-900 text-white' : 'bg-slate-100 text-slate-700 hover:bg-slate-200'
              }`}
              data-testid={`cut-pct-${p}`}
            >
              {p}%
            </button>
          ))}
          <span className="ml-2 text-xs text-slate-500">({sim.cutCount} segmenter)</span>
        </div>

        {kptWarn && (
          <div className="mb-5 p-3 bg-rose-50 border border-rose-200 rounded-lg flex items-start gap-3" data-testid="kpt-warning">
            <AlertTriangle className="w-5 h-5 text-rose-600 flex-shrink-0 mt-0.5" />
            <div className="text-sm">
              <p className="font-semibold text-rose-900">KPT-advarsel</p>
              <p className="text-rose-700 mt-0.5">
                Estimeret KPT 7d efter cut: <span className="font-semibold">{sim.newKpt7d.toFixed(2)}</span> — under målet på {KPT_TARGETS.week.toFixed(2)}.
                Overvej en mildere cut eller flyt budget til stærkere segmenter.
              </p>
            </div>
          </div>
        )}

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 mb-5">
          <SimMetric label="Sparet spend" value={`+${dkk(sim.savedSpend)}`} subtitle="månedligt" tone="positive" />
          <SimMetric label="Mistet revenue" value={`−${dkk(sim.lostRevenue)}`} tone="negative" />
          <SimMetric label="Profit-ændring" value={`${sim.netProfitChange >= 0 ? '+' : ''}${dkk(sim.netProfitChange)}`} tone={sim.netProfitChange >= 0 ? 'positive' : 'negative'} highlight />
          <SimMetric label="KPT 7d efter" value={sim.newKpt7d.toFixed(2)} subtitle={`mål: ${KPT_TARGETS.week.toFixed(2)}`} tone={kptWarn ? 'negative' : 'neutral'} />
          <SimMetric label="ROAS efter" value={`${sim.newRoas.toFixed(2)}x`} tone={sim.newRoas >= 3 ? 'positive' : 'neutral'} />
        </div>

        {/* List of cut segments */}
        <div>
          <p className="text-xs text-slate-500 uppercase tracking-wider font-semibold mb-2">Segmenter der skæres ({sim.cutCount}):</p>
          <div className="bg-slate-50 rounded-lg p-3 max-h-48 overflow-y-auto">
            <ul className="space-y-1.5 text-xs">
              {sim.cutSegments.map((s, i) => (
                <li key={s.id} className="flex items-center justify-between text-slate-700">
                  <span className="truncate">
                    <span className="text-slate-400 mr-2">{i + 1}.</span>
                    <span className="font-medium">{s.campaign}</span>
                    <span className="text-slate-500"> · {s.entryType} · {s.geo}</span>
                  </span>
                  <span className="text-slate-500 tabular-nums whitespace-nowrap ml-3">
                    {dkk(s.spend)} spend · profit/1K: <span className={s.profit < 0 ? 'text-rose-600 font-medium' : 'text-slate-700'}>{s.spend > 0 ? Math.round((s.profit / s.spend) * 1000) : 0} kr</span>
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

const SimMetric = ({ label, value, subtitle, tone, highlight }) => {
  const toneCls = tone === 'positive' ? 'text-emerald-700' : tone === 'negative' ? 'text-rose-700' : 'text-slate-900';
  return (
    <div className={`rounded-lg p-3 border ${highlight ? 'bg-slate-900 border-slate-900' : 'bg-slate-50 border-slate-200'}`}>
      <p className={`text-[10px] uppercase tracking-wider font-semibold ${highlight ? 'text-white/60' : 'text-slate-500'}`}>{label}</p>
      <p className={`text-lg font-bold mt-1 tabular-nums ${highlight ? 'text-white' : toneCls}`}>{value}</p>
      {subtitle && <p className={`text-[10px] mt-0.5 ${highlight ? 'text-white/50' : 'text-slate-400'}`}>{subtitle}</p>}
    </div>
  );
};

// ----------------------------------------------------------------------------
// FOOTER
// ----------------------------------------------------------------------------
const Footer = () => (
  <div className="mt-8 pt-5 border-t border-slate-200 flex items-center justify-between flex-wrap gap-2">
    <p className="text-xs text-slate-400">
      Marketing Analyse · v0.1 prototype · Data fornyes hver nat når koblet til rigtig kilde
    </p>
    <div className="flex items-center gap-3 text-xs text-slate-500">
      <span className="flex items-center gap-1.5"><span className="w-2 h-2 rounded-full bg-emerald-500"></span>Scale</span>
      <span className="flex items-center gap-1.5"><span className="w-2 h-2 rounded-full bg-slate-400"></span>Hold</span>
      <span className="flex items-center gap-1.5"><span className="w-2 h-2 rounded-full bg-amber-500"></span>Review</span>
      <span className="flex items-center gap-1.5"><span className="w-2 h-2 rounded-full bg-rose-500"></span>Cut</span>
    </div>
  </div>
);
